import { CHCStickyAnchorLinks } from "./sticky-anchor-links.component.js";
customElements.define("chc-sticky-anchor-links", CHCStickyAnchorLinks);
export {
  CHCStickyAnchorLinks
};
//# sourceMappingURL=sticky-anchor-links.js.map
